import React, { FunctionComponent } from "react";
import { Theme, makeStyles, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { animated } from "react-spring";
import { CardWithArrow } from "../../components/card-with-arrow/card-with-arrow";

const useStyles = makeStyles((theme: Theme) => ({
  mainSection: {
    maxHeight: `calc(100% - ${theme.spacing(12)}px)`,
    maxWidth: "100%",
    flex: 1,
    padding: theme.spacing(6),
    display: "flex",
  },

  mainSectionCard: {
    maxWidth: "100%",
    padding: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(3),
      maxHeight: "calc(80vh)",
    },
    width: "100%",
  },
  contentWrapper: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(9),
    paddingBottom: theme.spacing(9),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(9),
    },
    overflowX: "hidden",
    overflowY: "auto",
  },
}));

interface IBorderSectionWrapperProps {
  fullHeight?: boolean;
}

export const BorderSectionWrapper: FunctionComponent<IBorderSectionWrapperProps> = (props) => {
  const classes = useStyles();
  const { children } = props;
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  return (
    <animated.div className={classes.mainSection}>
      <Grid container>
        <CardWithArrow
          showArrow
          arrowDirection={isMd ? "left" : "top"}
          arrowPosition={isMd ? "start" : "center"}
          className={classes.mainSectionCard}
        >
          <Grid container item className={classes.contentWrapper}>
            {children}
          </Grid>
        </CardWithArrow>
      </Grid>
    </animated.div>
  );
};
